import {GET_TENANT_PACKAGES} from "../../Config/ApiUrl";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";

export default {
    // mixins: [],
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            isLocationModalActive: false,
            isLocationCreateOpenModalActive: false,
            selectedUrl: '',
            promptIcon: '',
            employeeId: '',
            modalClass: '',
            isModalActive: false,
            options: {
                showSearch: true,
                showFilter: true,
                cardViewComponent: 'app-package-card-view',
                name: this.$allLabel('packages'),
                url: GET_TENANT_PACKAGES,
                showCount: true,
                showClearFilter: true,
                responsive: true,
                showAction: true,
                actionType: "default",
                enableRowSelect: false,
                columns: [
                    {
                        title: this.$t('package'),
                        type: 'custom-html',
                        key: 'name',
                        isVisible: true,
                        modifier: (name) => {
                            return name ? name: '-';
                        }
                    },
                    {
                        title: this.$t('price'),
                        type: 'custom-html',
                        key: 'subscription_package',
                        isVisible: true,
                        modifier: (subscription_package) => {
                            // Ensure subscription_package is available and contains price
                            return subscription_package && subscription_package.price
                                ? subscription_package.price
                                : '-';
                        }
                    },
                    {
                        title: this.$t('user_limit'),
                        type: 'custom-html',
                        key: 'subscription_package',
                        isVisible: true,
                        modifier: (subscription_package) => {
                            // Ensure subscription_package is available and contains price
                            return subscription_package && subscription_package.user_limit
                                ? subscription_package.user_limit
                                : '-';
                        }
                    },
                    {
                        title: this.$t('location_limit'),
                        type: 'custom-html',
                        key: 'subscription_package',
                        isVisible: true,
                        modifier: (subscription_package) => {
                            // Ensure subscription_package is available and contains price
                            return subscription_package && subscription_package.location_limit
                                ? subscription_package.location_limit
                                : '-';
                        }
                    },
                    {
                        title: this.$t('billing_cycle'),
                        type: 'custom-html',
                        key: 'billing_cycle',
                        isVisible: true,
                        modifier: (billing_cycle) => `<span class="text-capitalize">${billing_cycle}</span>`
                    },
                    // {
                    //     title: this.$t('duration'),
                    //     type: 'custom-html',
                    //     key: 'duration',
                    //     isVisible: true,
                    //     modifier: (duration) => duration ? `<span class="text-capitalize">${duration}</span> months` : ''
                    // },
                    {
                        title: this.$t('modules'),
                        type: 'custom-html',
                        key: 'subscription_package',
                        isVisible: true,
                        // modifier: (modules) => modules ? `<span class="text-capitalize">${modules.join(', ')}</span>` : ''
                        modifier: (subscription_package) => {
                            const  modules = subscription_package.modules.filter(module => module !== "job_desk");
                            return subscription_package && subscription_package.modules
                                ? `<span class="text-capitalize" style="font-size: 14px;">${modules.join(', ')}</span>`
                                : '-';
                        }
                    },
                    {
                        title: this.$t('trial_period_default'),
                        type: 'custom-html',
                        key: 'trial_status',
                        isVisible: true,
                        modifier: (trial_status) => {
                            return trial_status
                                ? `<span class="text-capitalize">${trial_status}</span>`
                                : '';
                        }
                    },
                    {
                        title: this.$t('featured'),
                        type: 'custom-html',
                        key: 'featured',
                        isVisible: true,
                        modifier: (featured) => featured ? `<i class="fa fa-check-circle text-success"></i>` : ''
                    },
                    {
                        title: this.$t('ends_at'),
                        type: 'custom-html',
                        key: 'ends_at',
                        isVisible: true,
                        modifier: ends_at => {
                            return ends_at ? formatDateToLocal(ends_at) : '-';
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'expired',
                        isVisible: true,
                        modifier: expired => {
                            return `<span class="badge badge-pill text-capitalize text-${!expired ? 'success' : 'danger'} badge-${!expired ? 'active' : 'inactive'}">
                                ${!expired ? 'Active' : 'Expired'}
                            </span>`
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                rowLimit: 10,
                paginationType: "pagination",
                actions: [
                    {
                        icon: 'arrow-down',
                        title: this.$t('download'),
                        key: 'download'
                    },
                    // {
                    //     icon: 'arrow-down',
                    //     title: this.$t('edit'),
                    //     key: 'edit'
                    // },
                    {
                        icon: 'refresh-cw',
                        title: this.$t('Renew Subscription'),
                        key: 'renew',
                        modifier: row => {
                            return !this.$isAdmin() ? this.$t('Renew Subscription') : '';
                        }
                    },
                    /*{
                        title: this.$t('upgrade'),
                        // url: GET_ALL_LOCATIONS,
                        icon: 'arrow-up',
                        key: "upgrade",
                        modifier: row => {
                            return (row.id !== window.user.id || this.$isAdmin());
                        },
                    },
                    {
                        title: this.$t('downgrade'),
                        icon: 'arrow-down',
                        url: GET_TENANT_PACKAGES,
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        name: 'downgrade',
                        modifier: row => {
                            return (row.id !== window.user.id || this.$isAdmin());
                        },
                    }*/
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "created_at",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('name'),
                        key: "name",
                        type: "text",
                    },
                ]
            },
            selectedEmployees: [],
            isContextMenuOpen: false,
        }
    },
    methods: {
        openLocationModal() {
            this.isLocationModalActive = true;
        },
        setFilterValues(filterValue) {
            if (filterValue.date_range && typeof filterValue.date_range != 'string') {
                filterValue.date_range = JSON.stringify(filterValue.date_range)
            }
            this.$store.dispatch('updateFilterObject', filterValue)
        },
        setSearchValue(search) {
            this.$store.dispatch('updateFilterObject', {search: search})
        },
        getSelectedRows(data, isSelectedAll) {
            this.selectedEmployees = data;
            this.isContextMenuOpen = data.length;
        },
        exportInvoice(id) {
            const url = `${window.location.origin}/subscription/invoice/${id}/download`;
            window.open(url, '_blank'); // Open the invoice in a new tab or download directly
        },
        renewSubscription(id) {
            const url = `${window.location.origin}/subscription/invoice/${id}/download`;
            console.log(url);
            // window.open(url, '_blank'); // Open the invoice in a new tab or download directly
        },
        triggerActions(row, action, active) {


            // if (action.key === 'view_details') {
            //     window.location = urlGenerator(`${EMPLOYEES_PROFILE}/${this.employeeId}/profile`);
            // }

            if (action.key === 'edit') {
                // this.promptIcon = action.icon;
                // this.employeeId = row.id;
                // this.modalClass = action.modalClass;
                // console.log(row, action);
                // this.selectedUrl = `${action.url}/${row.id}`;
                // this.isModalActive = true;

            }

        },
    }
}